<template>
  <v-flex
    xs12
    lg12
    md12
  >
    <v-layout
      justify-end
      align-center
    >
      <prism-editor
        ref="codeEditor"
        v-model="code"
        class="my-editor"
        :highlight="highlighter"
        :style="handleEditorSize"
        line-numbers
        lang="html"
        insert-spaces
        @blur="emitHtml($event)"
      />
    </v-layout>
    <v-layout
      justify-end
      align-center
      class="bg-dark py-2"
    >
      <v-dialog
        v-model="dialog"
        width="1000"
      >
        <template v-slot:activator="{ on }">
          <btn-tooltip
            color="#6A6E7B"
            outlined
            :on-click="on.click"
          >
            <template slot="tooltip">
              Visualizar tudo
            </template>
            <v-icon>
              mdi-arrow-expand
            </v-icon>
          </btn-tooltip>
        </template>
        <v-card flat>
          <prism-editor
            v-model="code"
            class="my-editor"
            :highlight="highlighter"
            line-numbers
            lang="html"
            insert-spaces
            @blur="emitHtml($event)"
          />
        </v-card>
      </v-dialog>
      <btn-tooltip
        :on-click="handleSize"
      >
        <template slot="tooltip">
          Expandir ({{ checkNumberLines }} linhas)
        </template>
        <v-icon>
          {{ handleIcon }}
        </v-icon>
        {{ handleLabel }}
      </btn-tooltip>
    </v-layout>
  </v-flex>
</template>

<script>
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';
import BtnTooltip from './BtnTooltip.vue';

export default {
  name: 'VueEditorCode',
  components: {
    PrismEditor,
    BtnTooltip,
  },
  props: {
    value: {
      type: String,
      default() {
        return 'Copie e cole o template html aqui';
      },
    },
  },
  data: vm => ({
    html: vm.value,
    expand: false,
    dialog: null,
  }),
  computed: {
    code: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('update-code', value);
      },
    },
    handleEditorSize() {
      return !this.expand ? 'height: 100px;' : 'height: auto!important;';
    },
    handleLabel() {
      return !this.expand ? 'Expandir' : 'Minimizar';
    },
    handleIcon() {
      return !this.expand ? 'mdi-chevron-down' : 'mdi-chevron-up';
    },
    checkNumberLines() {
      return this.html.split('\n').length;
    },
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.js);
    },
    emitHtml(ev) {
      const { value } = ev.target;

      if (value !== this.code) {
        this.$emit('update-code', value);
      }
    },
    handleSize() {
      this.expand = !this.expand;
    },
  },
};
</script>

<style scoped >
  .my-editor {
    background: #2d2d2d;
    color: #ccc;
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 8px;
    border-radius: 2px;
  }
  .prism-editor__textarea:focus {
    outline: none;
  }
  .prism-editor-wrapper::-webkit-scrollbar{
    display: none;
  }

  .bg-dark{
    background: #2d2d2d;
    width: 100%;
    border-top: 1px solid #6A6E7B;
  }
</style>
